<template>
  <v-card align="center" justify="center" light min-width="30vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ user.user.firstName }}'s Accounts</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="pt-3 pb-1">
      <v-container v-if="view === 'GENERAL'" fluid>
        <v-data-table :headers="headers" :items="accounts" dense>
          <template v-slot:item.identifier="{ item }">
            <p class="my-0" style="font-size: 14px">{{ (item.identifier !== null)? truncateString(item.identifier, 35) : '' }}</p>
          </template>
          <template v-slot:item.automated="{ item }">
            <v-icon v-if="item.automated" color="green" small>fa-check-circle</v-icon>
            <p v-else class="my-0" style="font-size: 14px">None</p>
          </template>
          <template v-slot:item.verified="{ item }">
            <v-icon v-if="item.verified" color="blue" small>fa-check-circle</v-icon>
            <v-chip v-if="item.verified" class="ml-2" small @click="removeCheckView(item)">Remove Check
              <v-icon class="icon ml-2" color="black" x-small>fa-minus-circle</v-icon>
            </v-chip>
            <p v-else class="my-0" style="font-size: 14px">None</p>
          </template>
        </v-data-table>
        <v-row class="d-flex justify-center">
          <v-btn @click="close">Close</v-btn>
        </v-row>
      </v-container>
      <v-container v-else>
        <h2 class="text-center">Remove Check <v-icon class="ml-1 mt-n1" color="black" small>fa-minus-circle</v-icon></h2>
        <p class="text-center">Confirm do you want to remove the check for<br><b>{{ accountFullName }}</b> account?</p>
        <div class="d-flex align-center justify-center mt-7 mb-5">
          <v-btn @click="view = 'GENERAL'">« Cancel</v-btn>
          <v-btn class="ml-3" @click="removeCheck">Yes, Remove it!</v-btn>
        </div>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../repositories/helpDesk';

export default {
  name: "UserAccounts",
  props: {
    user: Object,
  },
  data() {
    return {
      view: 'GENERAL',
      accounts: [],
      selectedAccount: null,
      headers: [
        {text: 'Id', align: 'start', sortable: false, value: 'id',},
        {text: 'Identifier', align: 'start', sortable: false, value: 'identifier',},
        {text: 'Broker', align: 'start', sortable: true, value: 'broker.name',},
        {text: 'Type', align: 'start', sortable: false, value: 'type',},
        {text: 'Automated', align: 'start', sortable: false, value: 'automated',},
        {text: 'Verified', align: 'start', sortable: false, value: 'verified',},
      ],
    };
  },
  computed: {
    accountFullName() {
      return this.truncateString((this.selectedAccount.identifier !== null)? `${this.selectedAccount.broker.name} - ${this.selectedAccount.identifier}` :
          `${this.selectedAccount.broker.name} (Id ${this.selectedAccount.id})`);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.view = 'GENERAL';
      Repository.allBrokerAccountsOfUser(this.user.user.id).then((response) => {
        if (response.status < 400)
          this.accounts = response.data;
      });
    },
    removeCheckView(account) {
      this.selectedAccount = account;
      this.view = 'REMOVE_CHECK';
    },
    removeCheck() {
      let brokerAccount = {
        id: this.selectedAccount.id,
        broker: { id: this.selectedAccount.broker.id },
        user: { id: this.selectedAccount.user.id },
        type: this.selectedAccount.type.toUpperCase(),
        identifier: this.selectedAccount.identifier,
        currency: this.selectedAccount.currency,
        verified: false,
        automated: this.selectedAccount.automated,
      };

      Repository.updateBrokerAccount(brokerAccount).then((response) => {
        if(response.status < 400) {
          alert(`The verified from the ${this.selectedAccount.id} broker account was successfully removed!`);
          this.init();
        }
        else
          alert('An error occurred :(');
      });
    },
    truncateString(string, maxLength) {
      return (string.length <= maxLength)? string: string.slice(0, maxLength) + '...';
    },
    close() {
      this.$emit('closeWindow');
    },
  },
}
</script>

<style scoped>

</style>
